import { render, staticRenderFns } from "./ApprovalDialog.vue?vue&type=template&id=3148f890&scoped=true"
import script from "./ApprovalDialog.vue?vue&type=script&lang=ts"
export * from "./ApprovalDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3148f890",
  null
  
)

export default component.exports